import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageItem } from '../layout.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  @Input() pages!: PageItem[];

  @Output() toggleMenu = new EventEmitter();

  // Data oficial do Dia de Doar 2026: 01/12/2026
  // O mês 11 representa dezembro, pois no JavaScript os meses começam em 0.
  public dDay: Date = new Date(2026, 11, 1);

  openSameTab(ev: Event, href: string) {
    // impede comportamento padrão e qualquer interferência
    ev.preventDefault();

    // Navega na MESMA aba. Use assign() se quiser manter no histórico.
    // window.location.assign(href);
    window.location.replace(href); // substitui no histórico (sem empilhar)
  }

}